export default {"src":"/_next/static/media/GOOS.2a6220d2.svg","height":18,"width":18};